// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"point-progress-bar_progress-bar__2uAQG","circle":"point-progress-bar_circle__jzCr5","filled":"point-progress-bar_filled__2wUeU"};